import { Alignment, Button, Classes, Dialog, FormGroup, H5, HTMLSelect, InputGroup, Popover, Switch, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { ICalc, IEmpresa, IMemoria, IMemoriaCalculo, newEmpresa, newIMemoria } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { MemoriaStore } from "../../stores/memoria/MemoriaStore";
import { toast } from "react-toastify";
import { formatCnpj, formatCpf } from "../../utils";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { CalcStore } from "../../stores/calculo/CalcStore";
import CnpjCpfInput from "../utils/CnpjCpfInput";
import CurrencyInput from "../utils/CurrencyInput";
import LoadingModal from "../loading/LoadingModal";

var debounce = require('lodash.debounce');

const BrV = require("br-validations");

@observer
export class MemoriaCalculo extends React.Component<{}, {}> {

  obs = observable({
    fetchOptions: {} as any,
    select_empresa: newEmpresa() as IEmpresa,
    open_create: false,
    create_memoria: newIMemoria() as IMemoria,
    calcOptions: [] as any
  })

  constructor(props) {
    super(props);

    this.obs.fetchOptions = debounce(this.handleMemorias.bind(this), 800);

  }

  componentDidMount() {
    AppStore.setTitle("Memória de Cálculo");

    this.obs.select_empresa = newEmpresa()

    MemoriaStore.obs.memoria_calculo = []
    MemoriaStore.obs.current_page = 1
    MemoriaStore.obs.memoria_length = 0

  }

  async handleDeleteMemoria(row: any) {

    MemoriaStore.resetDeletarItems()

    this.onSelect(row, true)

    this.handleDelete()

  }

  async handleBuscaMemoria(e) {

    MemoriaStore.obs.current_page = 1

    this.handleMemorias()

    MemoriaStore.resetDeletarItems()

  }

  async handleMemorias() {

    if (!this.obs.select_empresa.cnpj) {
      toast.warn('Selecione uma Empresa.', {});
      return
    }

    let data = {
      cnpj: this.obs.select_empresa.cnpj,
      page: MemoriaStore.obs.current_page,
      limit: 50,
      modelo: MemoriaStore.obs.modelo,
      filter: MemoriaStore.obs.filters,
      estado: MemoriaStore.obs.estado,
      tipo: MemoriaStore.obs.entrada_saida
    }

    await MemoriaStore.handleMemorias(data)

    if (MemoriaStore.obs.estado == "RS") {

      CalcRSStore.load();

    } else {

      CalcStore.load();

    }

    MemoriaStore.resetDeletarItems()

  }

  async handleChangeBuscaMemoria(page: number) {

    MemoriaStore.obs.current_page = page

    this.handleMemorias()

    MemoriaStore.resetDeletarItems()

  }

  onSelectAll = (isSelect, rows) => {

    if (isSelect) {

      MemoriaStore.obs.deletarMemorias = rows.map(x => x.id);

    } else {

      MemoriaStore.resetDeletarItems();

    }

  };

  onSelect = (row, checked) => {

    if (checked) {

      MemoriaStore.obs.deletarMemorias.push(row.id);

    } else {

      MemoriaStore.obs.deletarMemorias = MemoriaStore.obs.deletarMemorias.filter(value => value != row.id)

    }

  };

  async handleSaveMemoria() {

    let memoria: any = this.obs.create_memoria

    if (memoria.calc_id == "selecione" || !memoria.calc_id) {
      toast.warning('Por favor, selecione um Cálculo.', {});
      return;
    }

    if (MemoriaStore.obs.entrada_saida == "entrada") {

      if (!memoria.cnpj_origem && memoria.cnpj_memoria) {
        toast.warning('Por favor, digite um CNPJ.', {});
        return;
      }

      memoria.cnpj_origem = memoria.cnpj_memoria ? memoria.cnpj_origem : ""
      memoria.cnpj_destino = this.obs.select_empresa.cnpj

    } else {

      if (!memoria.cnpj_destino && memoria.cnpj_memoria) {
        toast.warning('Por favor, digite um CNPJ.', {});
        return;
      }

      memoria.cnpj_destino = memoria.cnpj_memoria ? memoria.cnpj_destino : ""
      memoria.cnpj_origem = this.obs.select_empresa.cnpj

    }

    if (!memoria.cfop) {
      toast.warning('Por favor, digite um CFOP.', {});
      return;
    }

    if (!memoria.cofins) {
      toast.warning('Por favor, digite um COFINS.', {});
      return;
    }

    if (!memoria.cst) {
      toast.warning('Por favor, digite um CST.', {});
      return;
    }

    if (!memoria.ncm) {
      toast.warning('Por favor, digite um NCM.', {});
      return;
    }

    if (!memoria.pis) {
      toast.warning('Por favor, digite um PIS.', {});
      return;
    }

    if (!memoria.descricao) {
      toast.warning('Por favor, digite uma Descrição.', {});
      return;
    }

    if (!memoria.cest) {
      memoria.cest = null
    }

    memoria.modelo = MemoriaStore.obs.modelo
    memoria.estado = MemoriaStore.obs.estado
    memoria.mva = memoria.mva.toString()

    this.obs.open_create = false

    let resp = false

    if (memoria.id) {

      resp = await MemoriaStore.handleUpdateMemoria(memoria)

    } else {

      resp = await MemoriaStore.handleCreateMemoria(memoria)

    }

    if (resp) {

      MemoriaStore.obs.current_page = 1

      this.handleMemorias()

    }

    this.obs.create_memoria = newIMemoria()

  }

  handleFilterCalcs(calcs: any, tmp_tipo: string, tmp_modelo: string) {

    return calcs?.map((calc: ICalc) => {

      if (calc[tmp_tipo] == true && calc[tmp_modelo] == true) {

        let calc_nome = calc.nome.length >= 90 ? (calc.nome.substring(0, 90) + "...") : calc.nome

        return <option key={calc._id} value={calc._id} title={calc.nome}>{calc_nome}</option>

      }

    });

  }

  onClose() {

    this.obs.create_memoria = newIMemoria()

    this.obs.open_create = false

  }

  async handleDelete() {

    let resp = await MemoriaStore.handleDeleteMemorias()

    if (resp) {

      MemoriaStore.obs.current_page = 1

      this.handleMemorias()

    }

    MemoriaStore.resetDeletarItems()

  }

  openCreateMemoria = async () => {

    let tmp_tipo = MemoriaStore.obs.entrada_saida
    let tmp_modelo = MemoriaStore.obs.modelo

    if (MemoriaStore.obs.estado == "RS") {

      this.obs.calcOptions = this.handleFilterCalcs(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo)

    } else {

      this.obs.calcOptions = this.handleFilterCalcs(CalcStore.validForDate(), tmp_tipo, tmp_modelo)

    }

    this.obs.calcOptions.unshift(<option value="selecione">Selecione o Cálculo</option>,);

    this.obs.open_create = true

  }

  handleEditMemoria(row) {

    row.mva = parseFloat(row.mva)

    this.obs.create_memoria = row

    let tmp_tipo = MemoriaStore.obs.entrada_saida
    let tmp_modelo = MemoriaStore.obs.modelo

    if (MemoriaStore.obs.estado == "RS") {

      this.obs.calcOptions = this.handleFilterCalcs(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo)

    } else {

      this.obs.calcOptions = this.handleFilterCalcs(CalcStore.validForDate(), tmp_tipo, tmp_modelo)

    }

    this.obs.calcOptions.unshift(<option value="selecione">Selecione o Cálculo</option>,);

    this.obs.open_create = true

  }

  handleBuscaMemorias(e: any) {

    MemoriaStore.obs.current_page = 1

    this.obs.fetchOptions()

  }

  hanldeClearFiltros() {

    MemoriaStore.obs.current_page = 1
    MemoriaStore.obs.filters = {
      "cest": "",
      "ncm": "",
      "cfop": "",
      "cnpj_origem": "",
      "cnpj_destino": "",
      "descricao": "",
    }

    this.obs.fetchOptions()

  }

  render() {

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    let userPrincipal = AppStore.obs1.usuario ? AppStore.obs1.usuario.principal : false;

    function cnpjFormatter(cell, row) {

      if (BrV.cnpj.validate(cell)) {

        return formatCnpj(cell)

      } else if (BrV.cpf.validate(cell)) {

        return formatCpf(cell)

      }

      return cell

    }

    const buttonFormatter = (cell: string, row: IMemoriaCalculo) => {
      return (
        <>
          {userPrincipal || niveis_acesso.indexOf("c4") == 1
            ? <>
              <MDBBtn color="default" rounded size="sm" onClick={(e) => this.handleEditMemoria(row)}>
                <img src="/images/edit.png" width={25} />
              </MDBBtn>
              <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                <MDBBtn color="default" rounded size="sm">
                  <img src="/images/block.png" width={25} />
                </MDBBtn>
                <div>
                  <H5>Excluir memória?</H5>
                  <p>Você confirma excluir esta memória: {row.calc_nome}?</p>
                  <p>
                    Ao excluir essa memória o sistema não aplicará mais o
                    cálculo automaticamente.
                  </p>
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                    <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>
                      Cancelar
                    </Button>
                    <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={(e) => this.handleDeleteMemoria(row)}>
                      Excluir
                    </Button>
                  </div>
                </div>
              </Popover>
            </>
            : <></>
          }
        </>
      );
    };

    let items = MemoriaStore.obs.memoria_calculo?.map((memoria) => {
      return ({
        id: memoria._id,
        calc_nome: memoria.calc_nome,
        cest_ncm: (memoria.cest || "Sem Cest") + " / " + memoria.ncm,
        cest: memoria.cest,
        ncm: memoria.ncm,
        cnpj_destino: memoria.cnpj_destino,
        cnpj_origem: memoria.cnpj_origem,
        inserted_at: moment(memoria._insertedTS || memoria.inserted_at).add(3, "hours").format("DD/MM/YYYY") + " " + moment(memoria._insertedTS || memoria.inserted_at).add(3, "hours").format("HH:mm"),
        descricao: memoria.descricao,
        cfop: memoria.cfop,
        cst: memoria.cst,
        pis: memoria.pis,
        cofins: memoria.cofins,
        mva: memoria.mva,
        calc_id: memoria.calc_id,
        cnpj_memoria: memoria.cnpj_memoria
      });
    });

    const selectRow = {
      mode: "checkbox",
      clickToSelect: false,
      columnWidth: "40px",
      onSelectAll: this.onSelectAll,
      onSelect: this.onSelect,
    };

    let empresaText = this.obs.select_empresa.razao_social != ""
      ? `${this.obs.select_empresa.razao_social.substring(0, 60)}... (${formatCnpj(this.obs.select_empresa.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>

        <MDBRow md="7">

          <MDBCol md="4">
            <FormGroup className="empresaSelect" label={MemoriaStore.obs.entrada_saida == "entrada" ? "Empresa Destino" : "Empresa Origem"}>
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.handleBuscaMemoria(this.obs.select_empresa = e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup
              label="Tipo"
              className="selectFullWidth"
            >
              <select
                onChange={(e) => this.handleBuscaMemoria(MemoriaStore.obs.entrada_saida = e.target.value)}
                value={MemoriaStore.obs.entrada_saida}
                className="bp3-button bp3-align-left"
              >
                <option value="entrada">Entrada</option>
                <option value="saida">Saída</option>
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup
              label="Modelo"
              className="selectFullWidth"
            >
              <select
                onChange={(e) => this.handleBuscaMemoria(MemoriaStore.obs.modelo = e.target.value)}
                value={MemoriaStore.obs.modelo}
                className="bp3-button bp3-align-left"
              >
                <option value="nfe">NF-E</option>
                <option value="nfce">NFC-E</option>
                <option value="cte">CT-E</option>
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup
              label="Estado"
              className="selectFullWidth"
            >
              <select
                onChange={(e) => this.handleBuscaMemoria(MemoriaStore.obs.estado = e.target.value)}
                value={MemoriaStore.obs.estado}
                className="bp3-button bp3-align-left"
              >
                <option value="PA">PA</option>
                <option value="RS">RS</option>
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="CEST">
              <InputGroup
                style={{ borderRadius: "10px" }}
                placeholder="Filtrar (CEST)"
                value={MemoriaStore.obs.filters.cest}
                onChange={(e) => this.handleBuscaMemorias(MemoriaStore.obs.filters.cest = e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="NCM">
              <InputGroup
                style={{ borderRadius: "10px" }}
                placeholder="Filtrar (NCM)"
                value={MemoriaStore.obs.filters.ncm}
                onChange={(e) => this.handleBuscaMemorias(MemoriaStore.obs.filters.ncm = e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="CFOP">
              <InputGroup
                style={{ borderRadius: "10px" }}
                placeholder="Filtrar (CFOP)"
                value={MemoriaStore.obs.filters.cfop}
                onChange={(e) => this.handleBuscaMemorias(MemoriaStore.obs.filters.cfop = e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          {MemoriaStore.obs.entrada_saida == "entrada" ?
            <MDBCol md="2">
              <FormGroup label="CNPJ Origem">
                <CnpjCpfInput
                  onChange={(val) => this.handleBuscaMemorias(MemoriaStore.obs.filters.cnpj_origem = val)}
                  value={MemoriaStore.obs.filters.cnpj_origem}
                  disabled={false}
                />
              </FormGroup>
            </MDBCol>
            :
            <MDBCol md="2">
              <FormGroup label="CNPJ Destino">
                <CnpjCpfInput
                  onChange={(val) => this.handleBuscaMemorias(MemoriaStore.obs.filters.cnpj_destino = val)}
                  value={MemoriaStore.obs.filters.cnpj_destino}
                  disabled={false}
                />
              </FormGroup>
            </MDBCol>
          }

          <MDBCol md="4">
            <FormGroup label="Descrição">
              <InputGroup
                style={{ borderRadius: "10px" }}
                placeholder="Filtrar (Descrição)"
                value={MemoriaStore.obs.filters.descricao}
                onChange={(e) => this.handleBuscaMemorias(MemoriaStore.obs.filters.descricao = e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn className="btnDefault btnBuscarNfe mt25 btnClearFilters" onClick={() => this.hanldeClearFiltros()}>
              Limpar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        {this.obs.select_empresa.cnpj &&
          <div style={{ display: "flex", float: 'left' }}>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.openCreateMemoria()}>Criar Memória</MDBBtn>
          </div>
        }

        <div style={{ display: "flex", float: 'right' }}>
          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <Tooltip
              content={`Deletar ${MemoriaStore.obs.deletarMemorias.length}`}
              disabled={MemoriaStore.obs.deletarMemorias.length == 0}
            >
              <Button
                disabled={MemoriaStore.obs.deletarMemorias.length == 0}
                icon="issue"
              >
                Deletar Selecionados
              </Button>
            </Tooltip>
            <div>
              <H5>Confirmar exclusão</H5>
              <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>

                <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }} onClick={() => MemoriaStore.resetDeletarItems()}>
                  Cancelar
                </Button>

                <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleDelete()}>
                  Deletar
                </Button>
              </div>
            </div>
          </Popover>
        </div>


        <div style={{ marginTop: 50 }}>
          <BootstrapTable className="TableDefault" ref="table" data={items} selectRow={selectRow}>
            <TableHeaderColumn dataField="id" isKey={true} hidden>#</TableHeaderColumn>
            <TableHeaderColumn width={"150px"} dataField="calc_nome">Nome do Cálculo</TableHeaderColumn>
            <TableHeaderColumn width={"50px"} dataField="cest_ncm">CEST / NCM</TableHeaderColumn>
            <TableHeaderColumn width={"80px"} dataFormat={cnpjFormatter} dataField="cnpj_destino">CNPJ Destino</TableHeaderColumn>
            <TableHeaderColumn width={"80px"} dataFormat={cnpjFormatter} dataField="cnpj_origem">CNPJ Origem</TableHeaderColumn>
            <TableHeaderColumn width={"150px"} dataField="descricao">Descrição</TableHeaderColumn>
            <TableHeaderColumn width={"50px"} dataField="cfop">CFOP</TableHeaderColumn>
            <TableHeaderColumn width={"50px"} dataField="cst">CST</TableHeaderColumn>
            <TableHeaderColumn width={"50px"} dataField="pis">PIS</TableHeaderColumn>
            <TableHeaderColumn width={"50px"} dataField="cofins">COFINS</TableHeaderColumn>
            <TableHeaderColumn width={"80px"} dataField="inserted_at">Data do Cadastro</TableHeaderColumn>
            <TableHeaderColumn width={"50px"} dataFormat={buttonFormatter}>Ações</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={MemoriaStore.obs.current_page}
            totalCount={MemoriaStore.obs.memoria_length}
            pageSize={50}
            onPageChange={page => this.handleChangeBuscaMemoria(page)} />
        </div>

        <LoadingModal open={MemoriaStore.obs.loading} onClose={() => MemoriaStore.obs.loading = false} title={"Buscando memórias de cálculo"} />
        <LoadingModal open={MemoriaStore.obs.loading_delete} onClose={() => MemoriaStore.obs.loading_delete = false} title={"Deletando memórias"} />

        <Dialog
          isOpen={this.obs.open_create}
          onClose={() => this.onClose()}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">{this.obs.create_memoria.id ? "Editando Memória" : "Criar Memória"}</h2>

          <div style={{ display: "flex" }}>
            <FormGroup className="form-group" label="Cálculo" labelInfo="*" style={{ width: "90%" }}>
              <HTMLSelect onChange={e => this.obs.create_memoria.calc_id = e.target.value} value={this.obs.create_memoria.calc_id}>
                {this.obs.calcOptions}
              </HTMLSelect>
            </FormGroup>
            &nbsp;
            &nbsp;
            <FormGroup className="form-group" label="Memória CNPJ" style={{ width: "10%" }}>
              <Switch
                className="md5"
                innerLabelChecked="Sim"
                innerLabel="Não"
                checked={this.obs.create_memoria.cnpj_memoria}
                onChange={(e: any) => this.obs.create_memoria.cnpj_memoria = e.target.checked}
              />
            </FormGroup>
          </div>
            
          <div style={{ display: "flex" }}>
            {this.obs.create_memoria.cnpj_memoria ? 
              <>
                {MemoriaStore.obs.entrada_saida == "entrada" ?
                  <FormGroup label={"CNPJ Origem"} style={{ width: "50%" }} labelInfo="*">
                    <CnpjCpfInput
                      onChange={val => this.obs.create_memoria.cnpj_origem = val}
                      value={this.obs.create_memoria.cnpj_origem}
                      disabled={false}
                    />
                  </FormGroup>
                  :
                  <FormGroup label={"CNPJ Destino"} style={{ width: "50%" }} labelInfo="*">
                    <CnpjCpfInput
                      onChange={val => this.obs.create_memoria.cnpj_destino = val}
                      value={this.obs.create_memoria.cnpj_destino}
                      disabled={false}
                    />
                  </FormGroup>
                }
              </> 
            : <></>}
            &nbsp;
            <FormGroup className="form-group" label="CEST" style={{ width: "25%" }}>
              <InputGroup type="text" value={this.obs.create_memoria.cest} onChange={(e) => this.obs.create_memoria.cest = e.target.value} />
            </FormGroup>
            &nbsp;
            <FormGroup className="form-group" label="CFOP" labelInfo="*" style={{ width: "25%" }}>
              <InputGroup type="text" value={this.obs.create_memoria.cfop} onChange={(e) => this.obs.create_memoria.cfop = e.target.value} />
            </FormGroup>
          </div>

          <div style={{ display: "flex" }}>

            <FormGroup className="form-group" label="COFINS" labelInfo="*" style={{ width: "25%" }}>
              <InputGroup type="text" value={this.obs.create_memoria.cofins} onChange={(e) => this.obs.create_memoria.cofins = e.target.value} />
            </FormGroup>
            &nbsp;
            <FormGroup className="form-group" label="CST" labelInfo="*" style={{ width: "25%" }}>
              <InputGroup type="text" value={this.obs.create_memoria.cst} onChange={(e) => this.obs.create_memoria.cst = e.target.value} />
            </FormGroup>
            &nbsp;
            <FormGroup className="form-group" label="NCM" labelInfo="*" style={{ width: "25%" }}>
              <InputGroup type="text" value={this.obs.create_memoria.ncm} onChange={(e) => this.obs.create_memoria.ncm = e.target.value} />
            </FormGroup>
            &nbsp;
            <FormGroup className="form-group" label="PIS" labelInfo="*" style={{ width: "25%" }}>
              <InputGroup type="text" value={this.obs.create_memoria.pis} onChange={(e) => this.obs.create_memoria.pis = e.target.value} />
            </FormGroup>
            {/* &nbsp; */}
            {/* <FormGroup className="form-group" label="MVA" style={{ width: "25%" }}>
              <CurrencyInput value={this.obs.create_memoria.mva} precision={2} showIcon={false} onChange={val => this.obs.create_memoria.mva = val} />
            </FormGroup> */}
          </div>

          <FormGroup className="form-group" label="Descrição" labelInfo="*" style={{ width: "100%" }}>
            <InputGroup type="text" value={this.obs.create_memoria.descricao} onChange={(e) => this.obs.create_memoria.descricao = e.target.value} />
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveMemoria()} />
          </div>

        </Dialog>

      </>
    );
  }
}

export default MemoriaCalculo;
